module.exports = __webpack_public_path__ + "static/images/bulb.e1a7ca8f56f01c0ff9e15bcf9ffa70a3.svg";